import React from "react";
import './lastBtn.css';

const LastBtn = () => {
    return(
        <button id="nextBtn">
            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 3C17.082 3.41799 10.7238 10.1256 8.64921 12.3148C8.28339 12.7009 8.28711 13.3022 8.65341 13.6878L17.5 23" stroke="#163279" stroke-width="3" stroke-linecap="round"/>
</svg>
Last Project
 </button>
    )
}

export default LastBtn 